import React from 'react';
import { Route, Navigate } from 'react-router-dom';

/*
 * Every route under /courses, in one place so App.js and the route-ranking
 * test use the same table. The AI routes sit under the static prefix
 * /courses/ai/…, which React Router ranks above the LMS's /courses/:slug.
 *
 * `Private` wraps members-only pages (App.js's PrivateRoute). The hub and the
 * viewer are public: the hub asks visitors to sign in per tab, and the viewer's
 * access is decided server-side (CONTRACTS.md, "Web routes").
 */
export function courseRoutes({ Private, pages }) {
  const { Courses, CourseDetail, CoursePlayer, Wizard, Viewer, Build, Editor } = pages;
  return [
    <Route key="cb-ai" path="/courses/ai" element={<Navigate to="/courses?tab=mine" replace />} />,
    <Route key="cb-new" path="/courses/ai/new" element={<Private><Wizard /></Private>} />,
    <Route key="cb-link" path="/courses/ai/s/:token" element={<Viewer mode="link" />} />,
    <Route key="cb-link-lesson" path="/courses/ai/s/:token/lessons/:lessonId" element={<Viewer mode="link" />} />,
    <Route key="cb-build" path="/courses/ai/:courseId/build" element={<Private><Build /></Private>} />,
    <Route key="cb-edit" path="/courses/ai/:courseId/edit" element={<Private><Editor /></Private>} />,
    <Route key="cb-view" path="/courses/ai/:courseId" element={<Viewer mode="course" />} />,
    <Route key="cb-lesson" path="/courses/ai/:courseId/lessons/:lessonId" element={<Viewer mode="course" />} />,
    <Route key="courses" path="/courses" element={<Courses />} />,
    <Route key="lms-course" path="/courses/:slug" element={<Private><CourseDetail /></Private>} />,
    <Route key="lms-lesson" path="/courses/:slug/lessons/:lessonId" element={<Private><CoursePlayer /></Private>} />,
  ];
}
